import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [show, setShow] = useState(false);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const checkScroll = () => setShow(window.scrollY > 300);
    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, []);

  const isMobile = window.innerWidth <= 768;

  const buttonStyle = {
    position: 'fixed',
    bottom: isMobile ? '20px' : '30px',
    right: isMobile ? '58px' : '30px',

    backgroundColor: hover ? '#d3541c' : '#F26522',
    color: '#ffffff',
    border: 'none',
    padding: isMobile ? '10px 14px' : '12px 18px',
    borderRadius: '50%',
    fontSize: isMobile ? '16px' : '20px',
    cursor: 'pointer',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    zIndex: 999,
    transition: 'all 0.3s ease',
  };

  return show ? (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={buttonStyle}
    >
      ↑
    </button>
  ) : null;
};

export default ScrollToTopButton;
